export default __webpack_public_path__ + "static/it5-486c6005a778da8199172887553cbf1f.jpg";